import { UseTellescopeQueryOptions } from "../../types";
import { useTellescopeQuery } from "../../use-tellescope-query";

export interface TwilioTFNSearchResult {
  phoneNumber: string;
  friendlyName: string;
  capabilities: {
    voice?: boolean;
    sms?: boolean;
    mms?: boolean;
    fax?: boolean;
  };
  /** Usually null for TFN */
  locality: string | null;
  /** State code: usually null for TFN */
  region: string | null;
  /** Usually null for TFN */
  postalCode: string | null;
}

export interface TwilioSearchTFNRequest {
  areaCode?: string;
  contains?: string;
  limit?: number;
}

export interface TwilioSearchTFNQueryResponse {
  data: TwilioTFNSearchResult[];
}

export interface UseTwilioSearchTFNQueryOptions<TError = Error, TData = TwilioSearchTFNQueryResponse>
  extends Omit<UseTellescopeQueryOptions<"integrations", "proxy_read", TError, TData>, "model" | "method" | "request"> {
  request?: TwilioSearchTFNRequest;
}

export const useTwilioSearchTFNQuery = <TError = Error, TData = TwilioSearchTFNQueryResponse>({
  request,
  ...options
}: UseTwilioSearchTFNQueryOptions<TError, TData> = {}) =>
  useTellescopeQuery({
    model: "integrations",
    method: "proxy_read",
    request: {
      integration: "Twilio",
      type: "search-tfn",
      query: Object.values(request ?? {}).filter(Boolean).length ? JSON.stringify(request) : undefined,
    },
    ...options,
  });
